import { usePOST } from "../../../Tools/APIs/useMyAPI";
import { Col, Row } from "../../../Tools/Grid-system";
import { AddImage, Back, ButtonRed, Input } from "../../../components";

const OurPeopleEdit = () => {
  const { handleChange, img, setImg, setFormData, formData } = usePOST();
  return (
    <div>
      <Row justify={"center"}>
        <Col md={7} className="">
          <Row justify="center">
            <Col>
              <Input title="name" />
              <Input title="description" />
              <AddImage
                id="image"
                name="images"
                onChange={handleChange}
                // img={test}
                newimg={img}
                title="add image slider one"
                clickDelete={() => {
                  setImg("");
                  setFormData({ ...formData, images: "" });
                }}
              />
            </Col>

            <Col col={6}>
              <ButtonRed name="Add" className="h-full px-4 py-3" />
            </Col>
          </Row>
        </Col>
      </Row>
      <Back />
    </div>
  );
};

export default OurPeopleEdit;
